// Components==============
import AddUserModal, {
  AddUserModalContext,
} from 'components/UI/AddUserModal/AddUserModal';
import Search from 'components/UI/Search/Search';
import ShareCodeButton from 'components/UI/ShareCodeButton/ShareCodeButton';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import './ShareModal.module.scss';
// =========================

const CustomTop = () => {
  const translate = useTranslate();
  const { rootProject } = useContext(ProjectDetailsContext);
  const { value, setValue } = useContext(AddUserModalContext);

  return (
    <div styleName="content">
      <div>
        <h2>Sharecode</h2>
        <div styleName="twoColumn">
          <p>
            {translate('project.sharecode-description')}{' '}
            <b>{translate('project.sharecode-description-warning')}</b>
          </p>
          <ShareCodeButton
            sharecode={rootProject?.share_code}
            type="projects"
          />
        </div>
      </div>
      <div>
        <div styleName="bar" />
        <h2>{translate('general.terms.search-directly')}</h2>
        <div styleName="twoColumn">
          <p>
            {translate('project.direct-search-description')}{' '}
            <b>{translate('project.direct-search-description-warning')}</b>
          </p>
          <Search value={value} setValue={setValue} />
        </div>
      </div>
    </div>
  );
};

export default function ShareModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const translate = useTranslate();
  const { handleAddGroupMember, rootProject } = useContext(
    ProjectDetailsContext
  );

  const message = (user: UserEntity) =>
    rootProject?.members.find((m) => m.user_id === user.id)
      ? `  <b>(${translate('project.terms.already-in-group')})</b>`
      : user.alreadyInProject
      ? `  <b>(${translate('project.terms.already-in-project')})</b>`
      : '';

  return (
    <AddUserModal
      title={translate('project.actions.project-share')}
      message={message}
      onSubmit={handleAddGroupMember}
      setModalIsOpen={setModalIsOpen}
      customTop={<CustomTop />}
    />
  );
}
